const fontUrlMagnet =
  'https://res.cloudinary.com/dgg9enyjv/raw/upload/v1601025984/Magnet/fonts/'

const fontUrlLJB =
'https://res.cloudinary.com/dgg9enyjv/raw/upload/v1651582419/Invita/fonts/'


const fonts = `
@font-face {
  font-weight: 300;
  font-family: "Campton";
  src: url(${fontUrlMagnet}Campton_normal_300.woff) format("woff"),
    url(${fontUrlMagnet}Campton_normal_300.woff2) format("woff2"),
  font-style: normal;
}

@font-face {
  font-weight: 350;
  font-family: "Campton";
  src: url(${fontUrlMagnet}Campton_normal_350.woff) format("woff"),
    url(${fontUrlMagnet}Campton_normal_350.woff2) format("woff2"),
  font-style: normal;
}

@font-face {
  font-weight: 500;
  font-family: "Campton";
  src: url(${fontUrlMagnet}Campton_normal_500.woff) format("woff"),
    url(${fontUrlMagnet}Campton_normal_500.woff2) format("woff2"),
  font-style: normal;
}

@font-face {
  font-weight: 600;
  font-family: "Campton";
  src: url(${fontUrlMagnet}Campton_normal_600.woff) format("woff"),
    url(${fontUrlMagnet}Campton_normal_600.woff2) format("woff2"),
  font-style: normal;
}


@font-face {
  font-family: 'NewSpirit-Regular';
  src: url(${fontUrlMagnet}NewSpirit-Regular.woff) format("woff"),
    url(${fontUrlMagnet}NewSpirit-Regular.woff2) format("woff2");
}
@font-face {
  font-family: 'NewSpirit-Medium';
  src: url(${fontUrlMagnet}NewSpirit-Medium.woff) format("woff"),
    url(${fontUrlMagnet}NewSpirit-Medium.woff2) format("woff2");
  font-weight: 500;
}
@font-face {
  font-family: 'NewSpirit-Light';
  src: url(${fontUrlMagnet}NewSpirit-Light.woff) format("woff"),
    url(${fontUrlMagnet}NewSpirit-Light.woff2) format("woff2");
  font-weight: 300;
}

@font-face {
  font-weight: normal;
  font-family: "Reckless Neue";
  src: url(${fontUrlLJB}reckless/RecklessNeue-Regular.woff2) format("woff2"),
      url(${fontUrlLJB}reckless/RecklessNeue-Regular.woff) format("woff");
}
@font-face {
  font-weight: 250;
  font-family: "Lausanne";
  src: url(${fontUrlLJB}lausanne/TWKLausanne-250.woff2) format("woff2"),
      url(${fontUrlLJB}lausanne/TWKLausanne-250.woff) format("woff");
}
@font-face {
  font-weight: 350;
  font-family: "Lausanne";
  src: url(${fontUrlLJB}lausanne/TWKLausanne-350.woff2) format("woff2"),
      url(${fontUrlLJB}lausanne/TWKLausanne-350.woff) format("woff");
}
@font-face {
  font-weight: 650;
  font-family: "Lausanne";
  src: url(${fontUrlLJB}lausanne/TWKLausanne-650.woff2) format("woff2"),
      url(${fontUrlLJB}lausanne/TWKLausanne-650.woff) format("woff");
}
`

export default fonts
